<template>
  <el-container style="height: 100vh;">
    <el-aside style="width: 200px;">
      <Menu activeName="1-1"></Menu>
    </el-aside>
    <el-main style="display: flex;flex-direction: row;flex: 1;padding: 0;">
      <div class="place-list-div">
        <el-input placeholder="请输入内容" v-model="listParams.name" clearable @clear="clearSearch">
          <el-button slot="append" icon="el-icon-search" @click="searchPlace"></el-button>
        </el-input>
        <div class="infinite-list-wrapper place-list">
          <div v-if="placeList.length > 0" class="infinite-list" infinite-scroll-disabled="disabled"
            v-infinite-scroll="loadMoreHandle">
            <el-card :body-style="{ 'border': 'none', 'padding': '12px' }" class="box-card"
              :class="index === detailsIndex ? 'active-card' : ''" shadow="hover" v-for="(place, index) in placeList"
              v-bind:key="index">
              <div style="display: flex;flex-direction: column;" @click="showPlaceDetails(index)">
                <span>{{ place.name }}</span>
                <p style="font-size: 14px;color: #606266;margin-top: 1px;margin-bottom: 0;">{{ place.address }}</p>
                <div class="phone">
                  <span v-if="place.phone_name">{{ place.phone_name }}</span>
                  <span v-if="place.phone">({{ place.phone }})</span>
                </div>
                <p style="font-size: 12px;color: #909399;margin-bottom: 0;" v-if="place.remarks">{{ place.remarks }}</p>
              </div>
            </el-card>
          </div>

          <el-empty v-if="total == 0 && !loading" description="暂无地点"></el-empty>
          <el-divider v-if="loading">加载中...</el-divider>
          <el-divider v-if="noMore">没有更多了</el-divider>
        </div>
      </div>
      <div style="flex: 1;height: 100%;">
        <el-amap vid="map" @init="initMap" style="flex: 1;" @click="clickMap">
          <el-amap-control-geolocation @init="locationInit" :visible="true" @complete="getLocation"></el-amap-control-geolocation>
          <el-amap-marker v-if="placeList.length > 0" v-for="(item, index) in placeList" :key="'place-' + index"
            :vid="'place-' + index" anchor="center" :position="[item.locations.longitude, item.locations.latitude]"
                          @mouseover="handleMouseOver(item.id)"
                          @mouseout="handleMouseLeave">
            <div>
              <img src="/static/images/index/marker-2.png" alt="" style="width: 24px;height: 24px;">
            </div>
          </el-amap-marker>

          <el-amap-info-window v-if="placeList.length > 0" v-for="(item, index) in placeList"
                               :key="'place-window-' + index" :closeWhenClickMap="true"
                               :position="[item.locations.longitude, item.locations.latitude]" :autoMove="false" :offset="[0, -20]"
                               anchor="bottom-center" :visible="item.id == overConf.placeId">
            <div style="display: flex;flex-direction: column;padding:4px;margin-top: 4px;">
              <div style="font-size: 16px;color: #333;font-weight: 500">{{ item.name }}</div>
              <div style="font-size: 14px;color: #666;margin-top: 4px;">{{ item.address }}</div>
              <div style="font-size: 14px;color: #666;">客户：{{ item.phone_name }} 电话：{{ item.phone }}</div>
            </div>
          </el-amap-info-window>
        </el-amap>
      </div>
      <div style="position:absolute;top: 20px;left: 40vw;z-index: 99999;">
        <div style="background-color: #fff;width: 400px;display: flex;flex-direction: row;align-items: center;" v-if="mapSearchResp.total <= 0">
          <el-input v-model="mapSearchReq.city" style="width: 120px;" placeholder="城市"></el-input>
          <el-input id="mapSearch" placeholder="请输入地址" v-model="mapSearchReq.keyword" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="mapSearchFunc"></el-button>
          </el-input>
        </div>
        <div class="search-result" v-else>
          <div class="result-number">
            <el-button icon="el-icon-arrow-left" style="padding: 6px;" @click="backSearch"></el-button>
            <div class="result-tip">搜索 {{ mapSearchReq.keyword }}
              共{{ mapSearchResp.total }}个地点
            </div>
          </div>
          <el-pagination small class="page" layout="prev, pager, next" @current-change="handleCurrentChange"
                         :total="mapSearchResp.total">
          </el-pagination>
          <div class="search-place-list">
            <div class="search-item" v-for="item in mapSearchResp.list" @click="handleAddressClick(item)">
              <div style="font-size: 16px;font-weight: bold;">{{ item.name }}</div>
              <div style="padding-top: 4px;color: #808695;">{{ item.province }}{{ item.city }}{{
                  item.address
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="update-form" v-if="showDetailsDivState">
        <div class="form-header">
          <span style="font-size: 18px;font-weight: bold;">详情</span>
          <i class="el-icon-close" style="font-weight: bold;font-size: 20px;" @click="closePlaceDetails"></i>
        </div>
        <el-form label-position="left" label-width="80px" style="margin-top: 20px;padding: 0 15px;">
          <el-form-item label="地点名称">
            <el-input v-model="details.name" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="details.address" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model="details.phone_name" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="details.phone" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="details.remarks" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-input v-model="details.create_time" :readonly="true"></el-input>
          </el-form-item>
        </el-form>
        <div
          style="margin-top: 10px;display: flex;flex-direction: row;justify-content: flex-end;padding-right: 20px;padding-bottom: 20px;">
          <el-button size="mini" type="danger" round @click="deletePlace(details)">删除</el-button>
          <el-button size="mini" type="primary" round @click="showUpdatePlaceDiv">修改</el-button>
        </div>
      </div>

      <div class="update-form" v-if="showFormDivState">
        <div class="form-header">
          <span style="font-size: 18px;font-weight: bold;">地点编辑</span>
          <i class="el-icon-close" style="font-weight: bold;font-size: 20px;" @click="showFormDivState = false;"></i>
        </div>
        <el-form label-position="left" label-width="80px" style="margin-top: 20px;padding: 0 15px;">
          <el-form-item label="地点名称">
            <el-input v-model="placeForm.name"></el-input>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="placeForm.address" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model="placeForm.phone_name"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="placeForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="placeForm.remarks"></el-input>
          </el-form-item>
        </el-form>
        <div
          style="margin-top: 10px;display: flex;flex-direction: row;justify-content: flex-end;padding-right: 20px;padding-bottom: 20px;">
          <el-button size="mini" round @click="showFormDivState = false; showDetailsDivState = true;">取消</el-button>
          <el-button size="mini" type="primary" round @click="submitPlaceForm">确定</el-button>
        </div>
      </div>



      <el-dialog title="编辑地点" :visible.sync="updateSetting.dialogFormVisible">
        <el-form :model="updateForm">
          <el-form-item label="地点名称" :label-width="updateSetting.formLabelWidth">
            <el-input v-model="updateForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="updateSetting.formLabelWidth">
            <el-input v-model="updateForm.address" :disabled="true" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="客户名称" :label-width="updateSetting.formLabelWidth">
            <el-input v-model="updateForm.phone_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="客户手机号" :label-width="updateSetting.formLabelWidth">
            <el-input v-model="updateForm.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注" :label-width="updateSetting.formLabelWidth">
            <el-input v-model="updateForm.remarks" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updateSetting.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="savePlace">保 存</el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import store from 'store'
import Menu from '@/components/Menu.vue'
import Header from '@/components/Header.vue'
import Common from '@/components/Common.vue'
import {
  DeletePlace,
  SavePlace,
  GetTeamPlaceList,
  GetHDGTeamPlaceList,
  UpdatePlace,
  GetAllTeamPlaceList,
  SearchAddress
} from '../api/place.js'
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
  name: 'Index',
  components: { Menu, Common, Header },
  data() {
    return {
      showDetailsDivState: false, // 是否展示详情弹窗
      showFormDivState: false, // 是否展示详情弹窗
      noData: false,
      details: {},
      drawer: false,
      loading: true,
      loadmore: false,
      empty: false,
      detailsIndex: '',
      mapSearchReq: {
        city: '',
        keyword: '',
        page: 1
      },
      overConf: {
        placeId: 0,
        status: false,
      },
      mapSearchResp: {
        list: [],
        total: 0
      },
      keyword: '',
      updateSetting: {
        dialogFormVisible: false,
        formLabelWidth: '120px'
      },
      updateForm: {},
      listParams: {
        name: '',
      },
      page: 1, // 当前页码
      limit: 100, // 每页数据量
      pageTotal: 0,// 页码总数
      total: 0, // 数据总数
      placeList: [], // 数据
      link: '',
      map: {},
      icon: {},
      dingMarker: {},
      placeForm: {},
      mapConf: {
        mouseTool: null,
        center: [],
        zooms: [3, 19],
        mapStyle: 'normal',
        map: null,
        markerIcon: {},
        routeIndex: null,
        polygon: {
          draggable: false,
          visible: true,
          edit: true,
          path: [],
        }
      },
    }
  },
  mounted() {
    let token = store.get('token')
    if (!token) {
      this.$router.push({ name: 'login' })
    }
    this.getPlaceList()
  },
  computed: {
    noMore() {
      // 当起始页数大于等于总页数时停止加载
      return this.page >= this.pageTotal;
    },
    disabled() {
      return this.loading || this.noMore;
    }
  },
  methods: {
    initMap(e) {
      this.mapConf.map = e
    },
    clickMap() {
      if (this.status == 0) {
        this.mapConf.routeIndex = null
      }
    },
    locationInit(e){
      let that = this
      let map = this.mapConf.map
      e.getCurrentPosition(function (status,result) {
        if(status == 'complete'){
          let geocoder = new AMap.Geocoder(map);
          let position = result.position
          let lnglat = [position.lng,position.lat]
          console.log(lnglat)
          geocoder.getAddress(lnglat, function(geocoderStatus, geocoderRes) {
            console.log(geocoderStatus,geocoderRes)
            if (geocoderStatus === 'complete' && geocoderRes.regeocode) {
              let {city,province } = geocoderRes.regeocode.addressComponent
              if(city == "") {
                city = province
              }
              that.mapSearchReq.city = city
            } else {
              that.$notify({
                type:'warning',
                title:'警告',
                message:'定位失败,请允许定位并刷新浏览器'
              })
            }
          })
        }
      })
    },
    getLocation(e) {
    },
    // 加载更多
    loadMoreHandle() {
      this.loading = true;
      setTimeout(() => {
        this.page += 1; //滚动条到底时，页码自增 1
        this.getPlaceList(); //调用接口
      }, 500);
    },
    // 返回搜索框
    backSearch() {
      this.mapSearchReq.page = 1
      this.mapSearchResp.total = 0
      this.mapSearchResp.list = []
    },
    // 处理页码变更事件
    handleCurrentChange(e) {
      this.mapSearchReq.page = e
      this.mapSearchFunc()
    },
    // 点击搜索出的地址
    handleAddressClick(item) {
      let map = this.mapConf.map
      let that = this
      map.remove(this.dingMarker)
      let icon = new AMap.Icon({
        size: new AMap.Size(40, 40), // 图标尺寸
        image: '/static/images/index/ding.png', // Icon的图像
        imageSize: new AMap.Size(40, 40) // 根据所设置的大小拉伸或压缩图片
      })
      var location = item.location.split(',')
      let marker = new AMap.Marker({
        // eslint-disable-next-line no-undef
        position: new AMap.LngLat(location[0], location[1]),
        map: that.map,
        icon: icon,
      })
      map.setCenter(new AMap.LngLat(location[0], location[1]))
      map.add(marker)
      this.dingMarker = marker
      marker.setMap(map) //重置map

      this.placeForm = {
        name: item.name,
        address: item.city + item.address,
        location: item.location,
      }
      this.showFormDivState = true
    },
    handleMouseOver(id) {
      let that = this
      clearTimeout(this.hoverTimer)
      this.hoverTimer = setTimeout(function () {
        that.overConf.placeId = id
      }, 500)
    },
    handleMouseLeave() {
      this.overConf.placeId = 0
      clearTimeout(this.hoverTimer)
      this.$forceUpdate()
    },
    submitPlaceForm() {
      SavePlace(this.placeForm).then(res => {
        if (res.code === 200) {
          this.placeForm = {}
          this.showFormDivState = false
          this.$notify({
            type: 'success',
            message: '保存成功'
          })

          this.getPlaceList()
        } else {
          this.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    // 关键词搜索
    mapSearchFunc() {
      let that = this
      SearchAddress(this.mapSearchReq).then(res => {
        if (res.code === 200) {
          let {list,total} = res.data
          if(total <= 0) {
            this.$notify({
              type:'warning',
              title:'警告',
              message:'没有搜索到地址'
            })
            return false;
          }
          this.mapSearchResp = res.data
        }
      })
    },
    // 展示地点详情信息
    showPlaceDetails(key) {
      let map = this.mapConf.map
      this.detailsIndex = key
      this.details = this.placeList[key]
      let location = this.details.location.split(',')
      map.setCenter(new AMap.LngLat(location[0], location[1]))
      map.setZoom(17)
      this.showDetailsDivState = true
    },
    closePlaceDetails() {
      this.showDetailsDivState = false
      this.detailsIndex = ''
      this.details = {}
      this.map.setZoom(14)
    },
    // 显示修改地点的表单
    showUpdatePlaceDiv() {
      this.placeForm = this.details
      this.showDetailsDivState = false
      this.showFormDivState = true
    },
    // 搜索地点库
    searchPlace() {
      this.page = 1
      this.getPlaceList()
    },
    // 清除搜索内容
    clearSearch() {
      this.listParams.name = ''
      this.page = 1
      this.list = []
      this.getPlaceList()
    },
    // 获取所有团队地点
    getAllTeamPlaceList() {
      var that = this
      GetAllTeamPlaceList().then(res => {
        if (res.code === 200) {
          var list = res.data.list
          var markers = []
          for (let i = 0; i < list.length; i++) {
            var location = list[i].location.split(',')
            // eslint-disable-next-line no-undef
            let marker = new AMap.Marker({
              // eslint-disable-next-line no-undef
              position: new AMap.LngLat(location[0], location[1]),
              map: that.map,
              extData: { content: list[i].name },
              icon: that.icon,
              label: {
                direction: 'top',
                content: list[i].name
              }
            })
            markers.push(marker)
          }
          that.map.add(markers)
        }
      })
    },
    getPlaceList() {
      let that = this
      let page = this.page
      let limit = this.limit
      let params = {
        page: page,
        limit: limit,
        name: this.listParams.name
      }

      GetHDGTeamPlaceList(params).then(res => {
        that.loading = false
        if (res.code === 200) {
          let { list, total, pageTotal } = res.data
          this.placeList = [...this.placeList, ...list]
          this.total = total
          this.pageTotal = pageTotal
        } else {
          that.$notify({
            title: '错误',
            type: 'error',
            message: res.message,
          })
        }
      })
    },
    openUpdateForm(item) {
      this.updateForm = item
      this.updateSetting.dialogFormVisible = true
    },
    savePlace() {
      let that = this
      UpdatePlace(that.updateForm).then(res => {
        if (res.code === 200) {
          that.$notify({
            type: 'success',
            message: '保存成功',
            offset: 80
          })
          that.updateSetting.dialogFormVisible = false
          that.refreshPlaceList()
        } else {
          that.$notify({
            type: 'error',
            message: res.message,
            offset: 80
          })
        }
      })
    },
    refreshPlaceList() {
      this.placeList = []
      this.page = 1
      this.getPlaceList()
    },
    deletePlace(info) {
      var that = this
      this.$confirm('是否删除' + info.name + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        DeletePlace({ id: info.id }).then(res => {
          if (res.code === 200) {
            that.$notify({
              type: 'success',
              message: '删除成功'
            })
            that.showDetailsDivState = false
            that.refreshPlaceList()
          } else {
            that.$notify({
              type: 'error',
              message: res.message
            })
          }
        })
      }).catch(() => {
        this.$notify({
          type: 'info',
          message: '已取消删除'
        })
      })

    },
  }
}
</script>

<style scoped>
.map {
  flex: 1;
  height: 100%;
}

.search-place-list {
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  height: 80%;
}
.search-place-list::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, and Opera */
}
.place-list-div {
  width: 320px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  margin: 20px;
}

.place-list {
  overflow: auto;
  margin-top: 10px;
  flex: 1;
  padding-bottom: 20px;
}

.place-list::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, and Opera */
}

.phone {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  color: #606266;
  margin-top: 2px;
}

.update-form {
  display: flex;
  flex-direction: column;
  width: 340px;
  background-color: #fff;
  z-index: 9999;
  position: absolute;
  right: 50px;
  top: 80px;
}

.form-header {
  display: flex;
  flex-direction: row;
  height: 40px;
  background-color: #409EFF;
  color: #fff;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

.active-card {
  background-color: #ecf5ff;
}

.search-result {
  background-color: #fff;
  height: 80vh;
  width: 22vw;
  border-radius: 8px;
}

.result-number {
  width: 100%;
  border-bottom: 1px solid #dcdee2;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}

.result-tip {
  font-weight: bold;
  padding-left: 10px;
  font-size: 16px;
}

.page {
  padding: 10px 20px;
  border-bottom: 1px solid #dcdee2;
  width: 90%;
  margin: 0 auto;
}

.search-item {
  padding: 10px 20px;
  border-bottom: 1px solid #dcdee2;
  width: 90%;
  margin: 0 auto;
}

.import {
  position: fixed;
  right: 50px;
  bottom: 50px;
  padding: 10px;
  border-radius: 50%;
  box-shadow: 0 0 6px rgb(0 0 0 / 12%);
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue